export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref6555.6dc3f19c.jpg";